var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vl-feature',[_c('vl-geom-multi-line-string',{attrs:{"coordinates":[_vm.route]}}),_c('vl-style-box',[_c('vl-style-stroke',{attrs:{"color":_vm.routeColor,"width":10,"lineDash":_vm.lineDash.display ? [5, 10] : []}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }